import { motion } from "framer-motion";
import ListWithDescription from '@/components/elements/CustomLists/ListWithDescription';
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Table from '@/components/elements/Table/Table';
import TitleBar from '@/components/elements/TitleBar/TitleBar';
import TitleWithContent from '@/components/elements/TitleWithContent/TitleWithContent';
import vistasbrlatexplusImg from '@/assets/images/products/vistasbrlatexplus.png';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: "easeOut" },
  viewport: { once: true, amount: 0.2 },
};

const VistaSbrLatexPlus = () => {
  return (
    <div className="2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista SBR Latex Plus"
        subTitle="(Premium SBR Based Polymer for Repair and Waterproofing)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct
          title="Description"
          imageUrl={vistasbrlatexplusImg}
          content="Dr. Vista SBR Latex Plus is a milky-white, styrene-butadiene co~polymer latex liquid designed to improve waterproofing, bonding, and the physical properties of cementitious mortars, screeds, and concrete. It enhances durability, compressive strength, and tensile and flexural properties. Suitable for vertical and horizontal applications, both internal and external. Meets BS 6319 part II:1983 & ASTM C 190-85 standards."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Area of Application">
          <ListWithDescription
            items={[
              {
                title: "Bond Coat:",
                content: ["For bonding new concrete to old concrete, plaster, stone/brick masonry."]
              },
              {
                title: "Internally:",
                content: ["Basements, swimming pools, sunken/overhead tanks, sludge tanks, ducts, tunnels, underpasses, etc."]
              },
              {
                title: "Waterproofing Externally:",
                content: ["Above-ground structures."]
              },
              {
                title: "Waterproofing Suspended Floors:",
                content: ["Balconies, wet areas, plant rooms, chajjas, exposed roofs before finished screed, etc."]
              },
              {
                title: "Other Typical Applications:",
                content: ["Bedding tiles, fixing or re-fixing slip bricks."]
              },
              {
                title: "Concrete Repair:",
                content: ["Spalled concrete, floors, beams, precast slabs, chajjas, etc."]
              },
              {
                title: "Repair:",
                content: ["For repairing or creating waterproof plaster superior to regular plaster."]
              },
              {
                title: "Improves Durability:",
                content: ["Used as an admixture to improve the waterproofing, abrasion resistance, and overall durability of cementitious mixes."]
              }
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Appearance", "Free-flowing liquid"],
                ["Specific Gravity @30°C (g/ml)", "1.02 ± 0.02"],
                ["Non-Volatile Matter (%)", "42 – 43"],
                ["pH Value", "8 – 9"],
                ["Chemical Resistance", "Resists mild acids & alkalies"],
                ["Freeze-Thaw Resistance", "Excellent"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaSbrLatexPlus;
